import { useContext, useLayoutEffect } from "react";
import { DemoContext } from "contexts/demo";

export const useDatastoresTypeEffect = (
  rootQuery: string,
  typesObj: { res: any[]; isLoading: boolean; error: any }
) => {
  const { isDemo } = useContext(DemoContext);

  useLayoutEffect(() => {
    if (typesObj?.isLoading) return;
    const types = typesObj?.res;

    const root = document.querySelector(rootQuery);
    const options = { root, rootMargin: "10px" };
    if (!root) return;

    const scrollObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const element = entry.target;
        if (!element) return;

        if (entry.isIntersecting)
          return element.setAttribute("data-visible", "true");

        return element.setAttribute("data-visible", "false");
      });
    }, options);

    const timeout = setInterval(() => {
      let typesLength = types.reduce((a, b) => {
        let previousLength;

        if (a.length) {
          const [, prevItems] = a;
          previousLength = Object.keys(prevItems).length;
        } else {
          previousLength = a;
        }

        const [, items] = b;
        const length = Object.keys(items).length;

        return length + previousLength;
      });

      if (typesLength.length) typesLength = Object.keys(typesLength[1]).length;

      const submenus = document.querySelectorAll(".ant-menu-submenu");
      const dividers = document.querySelectorAll(".datastore-category");

      if (submenus.length !== typesLength) return;
      clearInterval(timeout);

      submenus.forEach((submenu) => {
        scrollObserver.observe(submenu);
      });

      dividers.forEach((divider) => {
        scrollObserver.observe(divider);
      });
    }, 500);
  }, [rootQuery, isDemo, typesObj]);
};
